module.exports = __webpack_public_path__ + "static/media/spider-black-widow.f87dbc4b.svg";